// 管理员认证相关API
import { request } from '@umijs/max';

/** 管理员登录请求参数 */
export interface AdminLoginRequest {
  username: string;
  password: string;
}

/** Token数据 */
export interface TokenData {
  access_token: string;
  refresh_token?: string;
  token_type: string;
  expires_in: number;
}

/** 统一API响应格式 */
export interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  code: number;
  data: T;
}

/** Token响应 */
export interface TokenResponse extends ApiResponse<TokenData> {}

/** 管理员登录 POST /api/v1/auth/admin-login */
export async function adminLogin(body: AdminLoginRequest, options?: { [key: string]: any }) {
  return request<TokenResponse>('/api/v1/auth/admin-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 管理员登出 POST /api/v1/auth/logout */
export async function adminLogout(options?: { [key: string]: any }) {
  return request<{ message: string }>('/api/v1/auth/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    ...(options || {}),
  });
}

/** 验证Token响应数据 */
export interface VerifyTokenData {
  valid: boolean; 
  user_id?: string; 
  username?: string;
  role?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
}

/** 验证管理员Token GET /api/v1/auth/verify-admin-token */
export async function verifyAdminToken(options?: { [key: string]: any }) {
  return request<ApiResponse<VerifyTokenData>>('/api/v1/auth/verify-admin-token', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 刷新Token POST /api/v1/auth/refresh-token */
export async function refreshAdminToken(refresh_token: string, options?: { [key: string]: any }) {
  return request<TokenResponse>('/api/v1/auth/refresh-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { refresh_token },
    ...(options || {}),
  });
}